import { actions } from './reducer'
import ssapi from 'lib/api/secondstepApi'
import { addNotification } from 'store/notifications'
import { ChangeEvent } from 'react'

export const onFileChange = (event: ChangeEvent<HTMLInputElement>) => {
  return async function (dispatch) {
    const file = event.target.files?.[0]
    if (file) {
      dispatch(actions.pacingFileSelected(file))
    }
  }
}

export const handlePacingUpload = (file: File) => {
  return async function (dispatch) {
    dispatch(actions.pacingFileSubmitting())
    const bodyFormData = new FormData()
    bodyFormData.set('file', file)

    try {
      const response = await ssapi.patchPacing(bodyFormData)
      const data = response.data
      dispatch(actions.pacingFileSucceeded(data))
      dispatch(
        addNotification({
          color: 'success',
          text: 'Successfully submitted pacing dates',
        }),
      )
    } catch (error) {
      const errorMsg =
        error.response && error.response.status === 400
          ? error.response.data.detail
          : "Something's gone wrong while uploading file. Please try again or file a ticket for assistance."
      dispatch(actions.pacingFileError(errorMsg))

      dispatch(
        addNotification({
          color: 'danger',
          text: errorMsg,
        }),
      )
    }
  }
}
